import axiosClient from './axiosClient';

export interface EffectiveCompanyContext {
  company_id: number;
  can_change: boolean;
  is_required: boolean;
  role: string;
}

export const getEffectiveCompanyContext =
  async (): Promise<EffectiveCompanyContext> => {
    const response = await axiosClient.get('/context/effective-company');
    return response.data;
  };
